import { FormattedMessage } from 'dibs-react-intl';

const DepositShortCopy = () => (
    <FormattedMessage
        id="dc.dibs-buyer-deposit.DepositShortCopy"
        defaultMessage="Pay 50% upfront and the rest when production is complete."
    />
);

export default DepositShortCopy;
